import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import {  ManageLibraryComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { EditShapeComponent } from '../../edit-shape/edit-shape.component';

@Component({
  selector: 'atw-shape-admin-config',
  templateUrl: './shape-admin-config.component.html',
  styleUrls: ['./shape-admin-config.component.scss']
})
export class AtwShapeAdminConfig extends AtwUpdateDbComponent {
  /** object đang chọn */
  @Input() objectChoosing: any;
  /** Thiết bị hiện tại (desktop, tablet_portrait, tablet_landscape, mobile_portrait, mobile_landscape) */
  @Input() device: any;
  /** Dữ liệu class của thiết bị hiện tại */
  @Input() class: any;
  /** Dữ liệu config của thiết bị hiện tại */
  @Input() config: any;
  /** Dữ liệu staticdata */
  @Input() staticdata: any;
  /** Dữ liệu blocks_of_page */
  @Input() blocks_of_page: any;
  /** Loại trang (page, admin, ...) */
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  imgAddress: string = ''; // biến để lưu address image
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  backgroundColor: any = [];

  // checkedRemoveShape: boolean = false;
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false
  };
  styles_field = [
    {
      title: 'nang_cao',
      index: 0,
    },
    {
      title: 'hieu_ung',
      index: 1,
    },
  ];
  // Các dạng hình dạng
  clipPaths: any = [
    {
      id: 1,
      name: 'square-default',
      clipPath: 'inset(0%)'
    },
    {
      id: 2,
      name: 'circle',
      clipPath: 'circle(35% at 50% 50%)',
    },
    {
      id: 3,
      name: 'triangle',
      clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    },
    {
      id: 4,
      name: 'diamond',
      clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
    },
    {
      id: 5,
      name: 'pentagon',
      clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
    },
    {
      id: 6,
      name: 'rabbet',
      clipPath: 'polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%)',
    },
    {
      id: 7,
      name: 'left-arrow',
      clipPath: 'polygon(0% 50%, 50% 0%, 50% 25%, 100% 25%, 100% 75%, 50% 75%, 50% 100%)',
    },
    {
      id: 8,
      name: 'right-arrow',
      clipPath: 'polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)',
    },
    {
      id: 9,
      name: 'left-point',
      clipPath: 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)',
    },
    {
      id: 10,
      name: 'right-point',
      clipPath: 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)',
    },
    {
      id: 11,
      name: 'left-chevron',
      clipPath: 'polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)',
    },
    {
      id: 12,
      name: 'right-chevron',
      clipPath: 'polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)',
    },
    {
      id: 13,
      name: 'message',
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%)',
    },
    {
      id: 14,
      name: 'unknown_1',
      clipPath: 'polygon(0% 0%, 58% 0%, 100% 100%, 0% 100%)'
    },
    {
      id: 15,
      name: 'unknown_2',
      clipPath: 'polygon(0% 0%, 100% 0%, 58% 100%, 0% 100%)'
    },
    {
      id: 16,
      name: 'unknown_3',
      clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)'
    },
    {
      id: 17,
      name: 'unknown_4',
      clipPath: 'polygon(0% 0%, 80% 0%, 100% 100%, 0% 100%)'
    },
    {
      id: 18,
      name: 'unknown_5',
      clipPath: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)'
    },
    {
      id: 19,
      name: 'unknown_6',
      clipPath: 'polygon(0% 0%, 100% 50%, 0% 100%, 25% 50%)'
    },
    {
      id: 20,
      name: 'square-outline',
      clipPath: 'polygon(0% 0%, 0% 100%, 25% 100%, 25% 25%, 75% 25%, 75% 75%, 25% 75%, 25% 100%, 100% 100%, 100% 0%)'
    },
    {
      id: 21,
      name: 'square-outline-2',
      clipPath: 'polygon(0% 0%, 0% 100%, 1px 100%, 1px 1px, calc(100% - 1px) 1px, calc(100% - 1px) calc(100% - 1px), 0 calc(100% - 1px), 0 100%, 100% 100%, 100% 0%)'
    },
    {
      id: 22,
      name: 'star',
      clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'
    },
    {
      id: 23,
      name: 'ellipse',
      clipPath: 'ellipse(25% 50% at 50% 50%)'
    },
    {
      id: 24,
      name: 'ellipse',
      clipPath: 'ellipse(50% 25% at 50% 50%)'
    }
  ];
  //Kiểu độ bao phủ
  style_cover = [
    {
      name: 'unset',
      title: 'Mặc định',
      image: '../../../../../../../assets/root/images/system/imgs/object-fit-default.jpg'
    },
    {
      name: 'cover',
      title: 'Bao phủ',
      image: '../../../../../../../assets/root/images/system/imgs/object-fit-cover.jpg'
    },
    {
      name: 'contain',
      title: 'Vừa vặn',
      image: '../../../../../../../assets/root/images/system/imgs/object-fit-contain.jpg'
    },
  ]
  //Kiểu màu đa sắc
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'Từ trái trên sang phải dưới',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'Từ phải trên sang trái dưới',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'Từ trái dưới sang phải trên',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'Từ phải dưới sang trái trên',
      deg: '315deg',
    },
  ];

  effect_hover = [];
  effect_hover_data: any = {};
  customize = [];

  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private nzMessageService: NzMessageService,
    private vhImage: VhImage,
    public vhEventMediator: VhEventMediator,
    private matdialog: MatDialog,
    private matDialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/data/effects/shape.json'),
    ]).subscribe(([background_colors, effects]: any) => {
      this.backgroundColor = background_colors;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
    })
  }


  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[1])
  }


  /**
   * Xử lý hình dạng của nút bấm
   * @param item : trả về mẫu hình dạng được chọn
   * @param e : trả về element được active
   */
  chooseItem(item, event) {
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    if (isPlatformBrowser(this.platformId)) {
      var activeShape = document.querySelector('.box-content .active') as HTMLElement;
      if (activeShape) activeShape.classList.remove('active');
      event.currentTarget.classList.add('active');
      const variants_shape = this.class.shape__parent;

      this.class.shape__parent['clip-path'] = item.clipPath
      this.class.shape__child['clip-path'] = item.clipPath
      // variants_shape.clip_path = item.clipPath;
      variants_shape.name = item.name;
      this.updateClass();
    }
  }
  

  /**
   * Xử lý chọn background-cover khi thêm hình ảnh vào hình dạng
   * @param option : trả về background-cover được chọn
   * @param e : trả về element được active
   */
  chooseOptionCover(option, e) {
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    const backgroundCover = this.class.shape__child
    this.config.option = option.name
    backgroundCover['background-size'] = option.name
    this.updateConfig();
    this.updateClass();
  }


  /**
   * Xử lý lấy image address để hiển thị
   * @param e : trả về đường dẫn ảnh
   */
  handleImageAddress(e) {
    // nhận địa chỉ đường dẫn ảnh bên ngoài web từ tham số e trả về
    const backgroundShape = this.class.shape__child
    this.imgAddress = e.target.value;
    backgroundShape['background'] = "url(" + this.imgAddress + ")";
    this.updateClass()
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
  * Hàm update object vào database.
  // */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {

  //     })
  // }
  

  //set border cho class shape__parent
  setBorder() {
    this.class.shape__parent['border-top-left-radius'] = this.class.shape__child['border-top-left-radius'];
    this.class.shape__parent['border-top-right-radius'] = this.class.shape__child['border-top-right-radius'];
    this.class.shape__parent['border-bottom-left-radius'] = this.class.shape__child['border-bottom-left-radius'];
    this.class.shape__parent['border-bottom-right-radius'] = this.class.shape__child['border-bottom-right-radius'];
    this.updateClass();
  }

  /**
  * @param index : vị trí phần tử muốn xóa
  * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      if (this.device == 'desktop') {
        this.config['background-color'].gradient_type = direction.type;
        this.config['background-color'].gradient_direction = direction.direction;
        this.class['shape__child']['background'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
        this.updateConfig();
        this.updateClass();
      } else {
        this.config['background-color'].gradient_type = direction.type;
        this.config['background-color'].gradient_direction =
          direction.direction;
        this.updateConfig();
      }
    }
  }
  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['shape__child'].background = "linear-gradient(" + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['shape__child'].background = this.config['background-color'].background;
    }
    this.updateObject();
  }

  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }


  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('upload').click();
  }

  //Lưu hình ảnh
  saveImage() {
    this.nzMessageService.success("Lưu ảnh thành công")
    this.updateObject();
  }
  /**
   * Lấy đường dẫn từ máy
   * @param e Biến lưu hình ảnh
   */
  onUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.vhImage.getThumbnailFromDesktop(file, 400, 400, "object-shape", null).then(
        (photoURL: any) => {
          this.objectChoosing.staticdata.link = photoURL;
          // this.class.shape__child['background-color'] = 'none'
          this.class.shape__child['background'] = `url('${this.staticdata.link}')`;
          this.saveImage();
        },
        (error) => {

          // this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
    }
    this.config['background-color']['is_load_image'] = true;
  }

  //Hàm xử lý boxShadow của clip-path
  boxShadow() {
    var config = this.config['box-shadow'];
    this.class.shape.filter = "drop-shadow(" + config.offset_x + 'px ' + config.offset_y + 'px ' + config.blur_radius + 'px ' + config.shadow_color + ")";
    // this.updateObject();
  }

  path = '/images';
  openLibrary() {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        this.objectChoosing.staticdata.img = data.href;
        this.saveImage();
      }
      this.path = data.path;
    });
  }


  /**
   * Cập nhật kiểu background, khi chuyển từ ảnh sang màu thì set màu mặc định
   */
  updateBgCheck() {
    if (this.config['background-color']['bg_check'] === 'color') {
      this.class['shape__child']['background'] = 'rgb(77, 138, 198)';
      this.updateClass();
    }
    this.updateConfig();
  }

  onRadiusChange(position: string, value: any): void {
    const num = Math.max(0, Math.min(100, Number(value)));
    this.class.shape__child[position] = `${num}px`;
  }

  onRadiusBlur(position: string, value: string): void {
    let num = parseInt(value || '0', 10);
    num = isNaN(num) ? 0 : Math.max(0, Math.min(100, num));
    this.class.shape__child[position] = `${num}px`;
    this.setBorder();
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openEditShape() {
    const dialogRef = this.matDialog.open(EditShapeComponent, {
      width: '80vw',
      height: '90vh',
      data: {
        clipPath: this.class.shape__parent['clip-path'],
        optionDisplay: this.config.switch_color ? 'color' : 'image',
        bgImage: this.config.background_image_restore,
        bgColor: this.class.shape__child['background'],
        clipPathsList: this.clipPaths,
      },
    });

    dialogRef.afterClosed().subscribe((clipPath) => {
      if (clipPath) {
        this.class.shape__parent['clip-path'] = clipPath;
        this.class.shape__child['clip-path'] = clipPath;
        this.updateClass();
      }
    });
  }
}
